// Central content + brand constants for the Global Eco solar landing page.

export const BRAND = {
  name: "Global Eco",
  full: "Global Eco's Green Energy Solutions",
  tagline: "Brighten Your Lives With Solar",
  phone: "+91 63044 08653",
  phoneRaw: "+916304408653",
  whatsapp: "916304408653",
  email: "globalecos7777@gmail.com",
  website: "www.globalecosgesolutions.com",
  location: "Hyderabad, Telangana, India",
  mapEmbed:
    "https://www.google.com/maps?q=Hyderabad%2C%20Telangana%2C%20India&output=embed",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#solutions" },
  { label: "Contact", href: "#contact" },
];

export const TRUST_CHIPS = [
  "Net Metering Assistance",
  "Professional Installation",
  "Lifetime Support",
];

export const TRUSTED_BY = [
  "Government",
  "Builders",
  "Factories",
  "Schools",
  "Hospitals",
  "Commercial Spaces",
];

export const SOLUTIONS = [
  {
    id: "residential",
    title: "Residential Solar",
    icon: "Home",
    desc: "Reduce household electricity expenses and make better use of your rooftop.",
    image:
      "https://images.unsplash.com/photo-1771479755134-9c1e3143c110?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "commercial",
    title: "Commercial Solar",
    icon: "Building2",
    desc: "Improve operating margins by reducing your business's dependence on the grid.",
    image:
      "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "industrial",
    title: "Industrial Solar",
    icon: "Factory",
    desc: "High-capacity solar systems engineered for energy-intensive operations.",
    image:
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "agriculture",
    title: "Agriculture Solar",
    icon: "Sprout",
    desc: "Reliable solar energy for farms, irrigation and agricultural infrastructure.",
    image:
      "https://images.unsplash.com/photo-1776918570415-52e7f702802a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "water-pumps",
    title: "Solar Water Pumps",
    icon: "Droplets",
    desc: "Solar-powered pumping solutions for dependable, off-grid water access.",
    image:
      process.env.PUBLIC_URL + "/solar-pump.png",
  },
  {
    id: "street-lighting",
    title: "Solar Street Lights",
    icon: "Lightbulb",
    desc: "Independent outdoor lighting systems for roads, layouts and campuses.",
    image:
      process.env.PUBLIC_URL + "/solar-street-lights-row.png",
  },
];

export const BENEFITS = [
  { icon: "IndianRupee", title: "Reduce Electricity Bills", desc: "Generate your own power and cut long-term dependence on grid tariffs." },
  { icon: "ShieldCheck", title: "25-Year Performance", desc: "Tier-1 panels backed by long, dependable performance warranties." },
  { icon: "Wrench", title: "Low Maintenance", desc: "Modern systems are durable and need only minimal routine upkeep." },
  { icon: "Zap", title: "Energy Independence", desc: "Protect your property against rising costs and power uncertainty." },
  { icon: "TrendingUp", title: "Increase Property Value", desc: "Solar-ready properties command higher resale and rental value." },
];

export const STEPS = [
  { n: 2, icon: "MapPin", title: "Site Inspection", desc: "Our team evaluates rooftop space, orientation and shadow." },
  { n: 3, icon: "PencilRuler", title: "Custom Design", desc: "We recommend the right capacity, layout and equipment." },
  { n: 4, icon: "HardHat", title: "Installation", desc: "Professionally installed, tested and commissioned." },
];

export const COMPARISON = [
  "Comprehensive Warranty",
  "Certified Tier-1 Components",
  "Professional Installation Crew",
  "Dedicated After-Sales Support",
  "Live Performance Monitoring",
];

export const PROJECTS = [
  { title: "Villa Rooftop", type: "Residential", capacity: "8 kW", savings: "₹9,200/mo", location: "Jubilee Hills", image: "https://images.unsplash.com/photo-1771479755134-9c1e3143c110?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: true },
  { title: "Textile Factory", type: "Industrial", capacity: "220 kW", savings: "₹2.8L/mo", location: "Medchal", image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Office Complex", type: "Commercial", capacity: "60 kW", savings: "₹74,000/mo", location: "Gachibowli", image: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Farm Irrigation", type: "Agriculture", capacity: "15 kW", savings: "₹18,000/mo", location: "Warangal", image: "https://images.unsplash.com/photo-1776918570415-52e7f702802a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: true },
  { title: "School Campus", type: "Commercial", capacity: "40 kW", savings: "₹52,000/mo", location: "Secunderabad", image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Independent Home", type: "Residential", capacity: "5 kW", savings: "₹6,100/mo", location: "Kompally", image: "https://images.unsplash.com/photo-1591866168743-4cf94aad7b31?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const TESTIMONIALS = [
  { name: "Rajesh Kumar", role: "Homeowner, Kondapur", rating: 5, text: "The team handled everything from subsidy paperwork to installation. My bill dropped from ₹6,800 to under ₹500 a month.", avatar: "https://images.unsplash.com/photo-1749700332031-cf99864959ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" },
  { name: "Priya Sharma", role: "Factory Owner, Medchal", rating: 5, text: "Professional from day one. The monitoring app lets me track generation live. ROI is tracking exactly as promised.", avatar: "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" },
  { name: "Anand Reddy", role: "Farmer, Warangal", rating: 5, text: "The solar water pump changed how we irrigate. No diesel, no grid worries. Support has been excellent throughout.", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" },
  { name: "Meena Iyer", role: "Business Owner, Gachibowli", rating: 5, text: "Clean install, zero mess, and genuine after-sales care. Highly recommend Global Eco for any commercial rooftop.", avatar: "https://images.unsplash.com/photo-1749700332031-cf99864959ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" },
];

export const SUBSIDIES = [
  { icon: "Sun", title: "PM Surya Ghar", desc: "Central scheme offering up to ₹78,000 subsidy for residential rooftop solar." },
  { icon: "Gauge", title: "Net Metering", desc: "Export surplus power to the grid and get credited on your electricity bill." },
  { icon: "Landmark", title: "State Subsidies", desc: "Additional Telangana state incentives layered on top of central benefits." },
  { icon: "Banknote", title: "Bank Loans", desc: "Low-interest solar loans and easy EMIs from partnered nationalised banks." },
];

export const FAQS = [
  { q: "Is solar energy a good investment?", a: "Absolutely! Most solar panel systems pay for themselves within 3 to 5 years through significantly reduced electricity bills, offering an excellent return on investment over their 25+ year lifespan." },
  { q: "How long do solar panels last?", a: "Quality Tier-1 solar panels carry a 25-year performance warranty and typically keep producing power for 25–30 years, with only a gradual, minimal drop in output over time." },
  { q: "Can solar work during power cuts?", a: "Grid-tied systems shut off during outages for safety. If you want backup during power cuts, we design hybrid systems with battery storage that keep essential loads running." },
  { q: "What maintenance does a solar system require?", a: "Very little — periodic panel cleaning and an annual inspection. Modern systems have no moving parts, and our monitoring alerts you if performance dips." },
  { q: "How long does installation take ?", a: "most residential installations are completed within 2-4 days after site approval Net-metering ." },
];
